// Temporary navigation override based on docs/getting-real/BAM-database/BAM-Quality-Validation/top-programs-by-category-count.md
// Context: requested two-week experiment to browse programs by descending category count without touching backend RPCs.

export interface CategoryPriorityEntry {
  rank: number;
  baciCode: string;
  categoryCount: number;
}

export interface OverrideNavTarget extends CategoryPriorityEntry {
  programId?: string;
}

const CATEGORY_PRIORITY_ENTRIES: CategoryPriorityEntry[] = [
  { rank: 1, baciCode: 'BLA', categoryCount: 384 },
  { rank: 2, baciCode: 'SUT', categoryCount: 224 },
  { rank: 3, baciCode: 'IP2', categoryCount: 184 },
  { rank: 4, baciCode: 'IPA', categoryCount: 179 },
  { rank: 5, baciCode: 'BEA', categoryCount: 168 },
  { rank: 6, baciCode: 'AFA', categoryCount: 165 },
  { rank: 7, baciCode: 'NIE', categoryCount: 165 },
  { rank: 8, baciCode: 'NAA', categoryCount: 160 },
  { rank: 9, baciCode: 'GBA', categoryCount: 154 },
  { rank: 10, baciCode: 'ABF', categoryCount: 153 },
  { rank: 11, baciCode: 'TCB', categoryCount: 122 },
  { rank: 12, baciCode: 'MAI', categoryCount: 120 },
  { rank: 13, baciCode: 'AB2', categoryCount: 114 },
  { rank: 14, baciCode: 'JG3', categoryCount: 113 },
  { rank: 15, baciCode: 'BRN', categoryCount: 107 },
  { rank: 16, baciCode: 'AB3', categoryCount: 104 },
  { rank: 17, baciCode: 'IB2', categoryCount: 98 },
  { rank: 18, baciCode: 'FBC', categoryCount: 88 },
  { rank: 19, baciCode: 'PB2', categoryCount: 85 },
  { rank: 20, baciCode: 'OFA', categoryCount: 81 },
  { rank: 21, baciCode: 'IAN', categoryCount: 76 },
  { rank: 22, baciCode: 'DRY', categoryCount: 70 },
  { rank: 23, baciCode: 'NA2', categoryCount: 66 },
  { rank: 24, baciCode: 'DPR', categoryCount: 60 },
  { rank: 25, baciCode: 'REA', categoryCount: 55 },
  { rank: 26, baciCode: 'FOR', categoryCount: 55 },
  { rank: 27, baciCode: 'COI', categoryCount: 47 },
  { rank: 28, baciCode: 'GO2', categoryCount: 46 },
  { rank: 29, baciCode: 'FAA', categoryCount: 40 },
  { rank: 30, baciCode: 'CBI', categoryCount: 38 },
  { rank: 31, baciCode: 'NBA', categoryCount: 37 },
  { rank: 32, baciCode: 'PTA', categoryCount: 35 },
  { rank: 33, baciCode: 'MI2', categoryCount: 34 },
  { rank: 34, baciCode: 'JGI', categoryCount: 28 },
  { rank: 35, baciCode: 'APA', categoryCount: 28 },
  { rank: 36, baciCode: 'BRF', categoryCount: 27 },
  { rank: 37, baciCode: 'JEN', categoryCount: 27 },
  { rank: 38, baciCode: 'AWA', categoryCount: 26 },
  { rank: 39, baciCode: 'LLF', categoryCount: 26 },
  { rank: 40, baciCode: 'CIN', categoryCount: 25 },
  { rank: 41, baciCode: 'SMBA', categoryCount: 25 },
  { rank: 42, baciCode: 'WD2', categoryCount: 24 },
  { rank: 43, baciCode: 'JG4', categoryCount: 23 },
  { rank: 44, baciCode: 'CIA', categoryCount: 21 },
  { rank: 45, baciCode: 'JN2', categoryCount: 20 },
  { rank: 46, baciCode: 'GCL', categoryCount: 20 },
  { rank: 47, baciCode: 'KIL', categoryCount: 20 },
  { rank: 48, baciCode: 'SFF', categoryCount: 20 },
  { rank: 49, baciCode: 'CLYM', categoryCount: 19 },
  { rank: 50, baciCode: 'JNM', categoryCount: 19 },
  { rank: 51, baciCode: 'CHH', categoryCount: 19 },
  { rank: 52, baciCode: 'NYF', categoryCount: 18 },
  { rank: 53, baciCode: 'BB2', categoryCount: 18 },
  { rank: 54, baciCode: 'NEF', categoryCount: 17 },
  { rank: 55, baciCode: 'GNW', categoryCount: 17 },
  { rank: 56, baciCode: 'CNB', categoryCount: 17 },
  { rank: 57, baciCode: 'GSW', categoryCount: 17 },
  { rank: 58, baciCode: 'GSE', categoryCount: 17 },
  { rank: 59, baciCode: 'HBF', categoryCount: 17 },
  { rank: 60, baciCode: 'JN3', categoryCount: 17 },
  { rank: 61, baciCode: 'CBR', categoryCount: 17 },
  { rank: 62, baciCode: 'GMW', categoryCount: 17 },
  { rank: 63, baciCode: 'LBF', categoryCount: 17 },
  { rank: 64, baciCode: 'PBF', categoryCount: 16 },
  { rank: 65, baciCode: 'TCP', categoryCount: 16 },
  { rank: 66, baciCode: 'ABE', categoryCount: 16 },
  { rank: 67, baciCode: 'HWN', categoryCount: 15 },
  { rank: 68, baciCode: 'IND', categoryCount: 15 },
  { rank: 69, baciCode: 'CSS', categoryCount: 15 },
  { rank: 70, baciCode: 'BS2', categoryCount: 15 },
  { rank: 71, baciCode: 'BRC', categoryCount: 14 },
  { rank: 72, baciCode: 'NAO', categoryCount: 13 },
  { rank: 73, baciCode: 'RWO', categoryCount: 13 },
  { rank: 74, baciCode: 'JG5', categoryCount: 13 },
  { rank: 75, baciCode: 'AAL', categoryCount: 12 },
  { rank: 76, baciCode: 'FSU', categoryCount: 11 },
  { rank: 77, baciCode: 'ACF', categoryCount: 11 },
  { rank: 78, baciCode: 'GEA', categoryCount: 11 },
  { rank: 79, baciCode: 'YAL', categoryCount: 10 },
  { rank: 80, baciCode: 'RE2', categoryCount: 10 },
  { rank: 81, baciCode: 'TFO', categoryCount: 10 },
  { rank: 82, baciCode: 'WLO', categoryCount: 10 },
  { rank: 83, baciCode: 'TKB', categoryCount: 9 },
  { rank: 84, baciCode: 'CHR', categoryCount: 9 },
  { rank: 85, baciCode: 'WR2', categoryCount: 9 },
  { rank: 86, baciCode: 'CCU', categoryCount: 9 },
  { rank: 87, baciCode: 'PUB', categoryCount: 9 },
  { rank: 88, baciCode: 'COL', categoryCount: 8 },
  { rank: 89, baciCode: 'CDN', categoryCount: 8 },
  { rank: 90, baciCode: 'CAN', categoryCount: 8 },
  { rank: 91, baciCode: 'CMY', categoryCount: 8 },
  { rank: 92, baciCode: 'CSR', categoryCount: 8 },
  { rank: 93, baciCode: 'CDF', categoryCount: 8 },
  { rank: 94, baciCode: 'CSM', categoryCount: 8 },
  { rank: 95, baciCode: 'CBA', categoryCount: 8 },
  { rank: 96, baciCode: 'MNS', categoryCount: 8 },
  { rank: 97, baciCode: 'MPI', categoryCount: 8 },
  { rank: 98, baciCode: 'PAS', categoryCount: 7 },
  { rank: 99, baciCode: 'BAI', categoryCount: 7 },
  { rank: 100, baciCode: 'CLA', categoryCount: 7 }
];

const CATEGORY_PRIORITY_INDEX = new Map<string, number>(
  CATEGORY_PRIORITY_ENTRIES.map((entry, index) => [entry.baciCode, index])
);

const HARDCODED_PROGRAM_IDS: Record<string, string> = {
  BLA: '2faa8ad4-9a1a-4108-ba49-3caca2261cb7',
  SUT: '5d3f273d-e23e-4aa3-bdcf-fd7033729b01',
  IP2: '4fb8db89-9578-4cc3-a255-3b15bdd6cf97',
  IPA: 'ca1a07b8-2244-478f-9223-6fd0bbe5438d',
  BEA: '37904772-c753-464b-aed7-44488e91ed4c',
  AFA: 'd5408a4a-daf0-48dc-ae65-e35ec58d807d',
  NIE: '08db659a-2e17-4f44-9e1d-7c039a69b2f8',
  NAA: '6e663175-d434-4b0c-a5fe-839115170e0a',
  GBA: 'aba11644-855c-4019-9d74-861734e4e7c5',
  ABF: '21138714-4ad5-4c3e-bf4a-a5e9528dbcdd',
  TCB: '26f340b7-b949-4177-8c43-280e224a2d70',
  MAI: '3bf94a83-0cc3-4efb-9714-2656cf75b83c',
  AB2: 'c6b22558-1b44-45d9-9645-78be92a93974',
  JG3: '522cbcda-cf61-49de-afab-32c5b6d2fbe2',
  BRN: '38e9d162-c70b-46b9-aa66-304533154d2f',
  AB3: 'c77ee174-0af4-4680-b930-e9fe73081659',
  IB2: '2788a802-1710-486f-9638-cb12a39799ef',
  IAN: 'f994f793-51a3-466b-a65f-320cd8b2dfff',
  DRY: 'b5fe39ea-ce07-4518-b191-e5e073900245',
  DPR: '982b09ff-e85b-4dc8-a353-39764d685b8f',
  COI: 'f3edf45f-c258-464a-8871-2573d69481bb',
  CBI: '1349014b-b67c-477a-a330-7c250190de5b',
  JGI: 'ff3c6327-4d23-41b0-a0fa-65f02a11c055',
  BRF: 'c0caef0e-8085-4671-a256-f81a5d612128',
  AWA: 'ca71a158-3fe9-4c45-a8c0-1ac8fa725683',
  CIN: '6bac1c80-1de8-40f7-ae01-dc165ce7c2b4',
  WD2: '066aa370-c8e9-4070-8c52-a8f0b8289f8e',
  JG4: 'aa6f7844-349f-4941-b38d-d3b697179ac4',
  CIA: '4b9848db-29ff-4113-9f3c-0ce590710ffa',
  JN2: 'f0cbade2-28de-4ec2-b1b4-7a909cae82f2',
  JNM: '8dcd9737-5e68-47fd-ba46-912580989a6c',
  CHH: 'f03f500b-bd0f-4f06-b621-baab7f178e3e',
  TCP: '74c08cce-afd9-4931-a3f5-ad31adcc0afe',
  BRC: 'f67fe321-7239-46b5-8a9e-c78d8244a147',
  JG5: '050d4e04-064e-4b48-bb7e-b3bb3ecdc01c',
  CHR: '2f380a65-6e5b-48bc-accb-b7b40a5a6254',
  CCU: 'd588e313-386c-41a7-ae5e-9262825039ff',
  COL: 'bc5f37cd-dc22-441c-b6a5-b84a0a3c0910',
  CAN: '82a31919-acdd-40e8-8c72-f4c74d2023fa',
  CMY: '59f39c1b-aeff-40d5-8c54-196164f7c80d',
  CSM: '2a50ac51-fdce-49bc-aada-5857e7d90204',
  CBA: 'af5fa54a-3269-496e-9cb5-1d6b9c9167ad',
  CLA: '55bd6041-8c80-4b23-86c5-d05a4ddf100d'
};

const buildTarget = (entry: CategoryPriorityEntry | undefined): OverrideNavTarget | undefined => {
  if (!entry) {
    return undefined;
  }
  return {
    ...entry,
    programId: HARDCODED_PROGRAM_IDS[entry.baciCode]
  };
};

export const CATEGORY_PRIORITY_ORDER: ReadonlyArray<CategoryPriorityEntry> = CATEGORY_PRIORITY_ENTRIES;

export function isCategoryPriorityProgram(baciCode: string | null | undefined): boolean {
  if (!baciCode) {
    return false;
  }
  return CATEGORY_PRIORITY_INDEX.has(baciCode);
}

export function getOverrideNavigationTargets(
  baciCode: string | null | undefined
): { previous?: OverrideNavTarget; next?: OverrideNavTarget } | null {
  if (!baciCode) {
    return null;
  }
  const normalized = baciCode.trim();
  if (!normalized) {
    return null;
  }

  const index = CATEGORY_PRIORITY_INDEX.get(normalized);
  if (typeof index !== 'number') {
    return null;
  }

  const previous = buildTarget(CATEGORY_PRIORITY_ENTRIES[index - 1]);
  const next = buildTarget(CATEGORY_PRIORITY_ENTRIES[index + 1]);

  if (!previous && !next) {
    return null;
  }

  return { previous, next };
}

export function getHardcodedProgramId(baciCode: string | null | undefined): string | undefined {
  if (!baciCode) {
    return undefined;
  }
  return HARDCODED_PROGRAM_IDS[baciCode.trim()];
}
